<script setup lang="ts">
import {ref, watch} from "vue";
import {useRouter} from "vue-router";
import {getGroup} from "@/Services/groups";
import {getGroupMember} from "@/Services/group-members";
import {withdrawInvitation} from "@/Services/invitations";
import {useToast} from "primevue/usetoast";
import {PageLoading} from "../../../Components/Global";

const $router = useRouter();
const toast = useToast();
const currentRoute = $router.currentRoute;

const group = ref();
const loadGroup = () => {
    // if (currentRoute.value.params.group) {
    //     getGroupGroup(currentRoute.value.params.group, currentRoute.value.params.group).then(
    //         ({data}) => (group.value = data),
    //     );
    // } else {
    // }
    getGroup(currentRoute.value.params.group).then(({data}) => (group.value = data));
};
loadGroup();

const invitationWithdrawn = async (invitation: string) => {
    await withdrawInvitation(invitation);
    toast.add({
        severity: "success",
        summary: "Success",
        detail: "Invitation has been withdrawn.",
        life: 3000,
    });
    group.value.invitations = group.value.invitations.filter((i) => i.id !== invitation);
};

const memberAdded = async (member: string, invitation: string) => {
    const {data} = await getGroupMember(group.value.id, member);
    group.value.members.push(data);
    group.value.invitations = group.value.invitations.filter(
        (existingInvitation) => existingInvitation.id !== invitation,
    );
};

watch(currentRoute, () => {
    if (currentRoute.value.name === "groups.edit") {
        loadGroup();
    }
});
</script>
<template>
    <div>
        <router-view
            v-if="group"
            :group="group"
            @member-added="memberAdded"
            @invitation-withdrawn="invitationWithdrawn"
        />
        <PageLoading v-if="!group" />
    </div>
</template>
<style scoped></style>
